import { render, staticRenderFns } from "./RoomProductsC.vue?vue&type=template&id=06b26fb7&"
import script from "./RoomProductsC.vue?vue&type=script&lang=js&"
export * from "./RoomProductsC.vue?vue&type=script&lang=js&"
import style0 from "./RoomProductsC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports